export default __webpack_public_path__ + "static/media/box-image-read-more.455b5ce3.png";